import cx from 'classnames';
import React, { ElementType, HTMLAttributes } from 'react';
import { getSizeClass } from '../../utils/main';
import { ModalBsSize } from '../../modal.types';

export type ModalTitleProps = {
  componentClass?: ElementType;
  bsClass?: string;
  bsSize?: ModalBsSize;
} & HTMLAttributes<HTMLElement>;

export const ModalTitle: React.FC<ModalTitleProps> = ({
  componentClass: Component = 'h4',
  className,
  bsClass = 'modal-title',
  bsSize,
  ...rest
}) => {
  return (
    <Component {...rest} className={cx(bsClass, getSizeClass(bsClass, bsSize), className)} />
  );
};
